<template lang="pug">
    m-form(ref="form" disableDivider="" )
        template(#content-template="" class="ma-0")
            v-layout
                v-flex(xs12)
                    e-input-risk-assessment-object(v-model="form.object" ref="object" @input="validateObjectInput")

</template>

<script>
    import baseForm from "@mixins/components/modules/forms/base";
    import customValidation from "@mixins/validation/_custom";
    import {compact as _compact} from 'lodash';
    import {createNamespacedHelpers} from 'vuex';

    const {mapActions} = createNamespacedHelpers('riskAssessments');

    let name = 'm-form-risk-assessment';
    export default {
        name: name,
        mixins: [baseForm, customValidation],
        props: {
            name: {
                type: String,
                default: name
            }
        },
        data: () => ({
            form: {
                object: null
            }
        }),
        methods: {
            ...mapActions({
                requestCreateAssessment: 'create'
            }),
            async createAssessment() {
                return await this.requestCreateAssessment(this.form.object._id)
            },
            async getObject(){
                return this.form.object._id;
            },
            async submit() {
                const formValid = await this.$validator.validateAll();
                const validObjectInput = this.validateObjectInput();
                if(formValid && validObjectInput){
                    const ra = await this.createAssessment();
                    this.notify.success(this.$t('notifications.success.risk-assessment-created', {name:this.form.object.name}));
                    return ra._id
                } else {
                    const el = document.querySelector(".v-messages__message");
                    el.scrollIntoView({behavior: "smooth" ,block: "center"});
                    this.notify.error(this.$t('notifications.errors.formErrors.invalid'))
                }
            },
            validateObjectInput() {
                return this.customAutocompleteRequireValidation(_compact([this.form.object]), this.$refs.object.name, {
                    rule: 'required',
                    data: [this.$refs.object.label]
                });
            },
            clear(){
                this.$refs.object.clear();
                this.form.object = null
            }
        }
    }
</script>

<style scoped>

</style>
